import { IProduct } from '../model/types';

export function isProduct(products: unknown[]): products is IProduct[] {
  return (products[0] as IProduct)?.toppings !== undefined;
}
